import config from 'config'
import { createLogic } from 'redux-logic'
import { fetchAction, getDateForRequest } from 'utils'

import { FETCH_DELAYED_STORES } from '../../home/constants'
import {
  ACTIVE_CLOSED_TAB,
  DELAYED_RTLOG_TAB,
  DELAYED_STORES_TAB,
  FETCH_CLOSED_REPORTING_ONLY_STORES,
  FETCH_CLOSED_REPORTING_ONLY_STORES_ERROR,
  FETCH_CLOSED_REPORTING_ONLY_STORES_SUCCESS,
  SET_SELECTED_VALUE,
  ZERO_REPORTING_TAB,
} from './constants'

const fetchClosedReportingOnlyStores = createLogic({
  type: FETCH_CLOSED_REPORTING_ONLY_STORES,
  latest: true,

  async process({ getState }, dispatch, done) {
    try {
      const state = getState()
      const { dateCurrent } = state.datePicker
      const response = await fetchAction(config.api.stores, {
        dateCurrent: getDateForRequest(dateCurrent),
        closedReportingOnly: true,
        ecoms: true,
        necoms: true,
      })

      dispatch({
        type: FETCH_CLOSED_REPORTING_ONLY_STORES_SUCCESS,
        data: response.data,
      })
    } catch (error) {
      dispatch({ type: FETCH_CLOSED_REPORTING_ONLY_STORES_ERROR })
    }
    done()
  },
})

const channelSelectedValue = createLogic({
  type: SET_SELECTED_VALUE,
  async process({ getState }, dispatch, done) {
    const state = getState()
    const { selectedValue } = state.componentsCompleteness

    const storesTabs = [DELAYED_RTLOG_TAB, DELAYED_STORES_TAB, ZERO_REPORTING_TAB, ACTIVE_CLOSED_TAB]

    if (storesTabs.includes(selectedValue)) {
      dispatch({ type: FETCH_DELAYED_STORES })
    }

    done()
  },
})

export default [fetchClosedReportingOnlyStores, channelSelectedValue]
